import { render } from "./InputCheckbox.vue?vue&type=template&id=4280bebd&ts=true"
import script from "./InputCheckbox.vue?vue&type=script&lang=ts"
export * from "./InputCheckbox.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__